<script>
import { Pie } from 'vue-chartjs';

const _ = require('lodash');

export default {
  extends: Pie,
  props: ["chartData", "options"],
  mounted() {
    this.renderPieChart();
  },
  methods: {
    renderPieChart: function () {
      this.renderChart(
        _.cloneDeep(this.chartData),
        _.cloneDeep(this.options)
      );
    },
  },
  watch: {
    chartData: {
      handler: function () {
        this.renderPieChart();
      },
      deep: true,
    },
  },
};
</script>
